/** @file turnFacing: body facing moved toward a heading rounded to the facing steps, limited by a turn rate. */
import { clamp } from '@zilo/pose3d-std/math/clamp';
import { wrapDegrees } from '@zilo/pose3d-std/math/wrapDegrees';

/**
 * Decision 16: target = `headingDeg` rounded to `360 / steps` in world space (`free` = unrounded), reached the short
 * way by at most `turnRateDeg` per call (`<= 0` = at once); the result is in [0, 360).
 */
export function turnFacing(currentDeg: number, headingDeg: number, steps: number | 'free', turnRateDeg: number): number {
  const step = steps === 'free' ? 0 : 360 / steps;
  const target = wrapDegrees(step > 0 ? Math.round(headingDeg / step) * step : headingDeg);
  let delta = wrapDegrees(target - currentDeg);
  if (delta > 180) delta -= 360;
  if (turnRateDeg > 0) delta = clamp(delta, -turnRateDeg, turnRateDeg);
  return wrapDegrees(currentDeg + delta);
}
